
export const BOOKING_STATUS_CONFIG = [
    { status: 'BOOKED_PENDING_CONFIRMATION', display: 'Booked Pending Confirmation', color: '#FF0000', fontColor: 'fontWhite', isTerminal: false },
    { status: 'PT_RESCHEDULED_PENDING_CONFIRMATION', display: 'PT Rescheduled Pending Confirmation', color: '#FF0000', fontColor: 'fontWhite', isTerminal: false },
    { status: 'CL_RESCHEDULED_PENDING_CONFIRMATION', display: 'CL Rescheduled Pending Confirmation', color: '#FF0000', fontColor: 'fontWhite', isTerminal: false },
    { status: 'BOOKED_CONFIRMED', display: 'Booked Confirmed', color: '#866BD9', fontColor: 'fontWhite', isTerminal: false },
    { status: 'PT_RESCHEDULED_CONFIRMED', display: 'PT Rescheduled Confirmed', color: '#866BD9', fontColor: 'fontWhite', isTerminal: false },
    { status: 'CL_RESCHEDULED_CONFIRMED', display: 'CL Rescheduled Confirmed', color: '#866BD9', fontColor: 'fontWhite', isTerminal: false },
    { status: 'CANCELLED_NO_SHOW', display: 'Cancelled No Show', color: '#ED8056', fontColor: 'fontBlack', isTerminal: true },
    { status: 'CANCELLED', display: 'Cancelled', color: '#ED8056', fontColor: 'fontBlack', isTerminal: true  },
    { status: 'CLINICAL_SERVICE_COMPLETED', display: 'Clinical Service Completed', color: '#007F61', fontColor: 'fontWhite', isTerminal: false },
    { status: 'COMPLETED', display: 'Completed', color: '#005841', fontColor: 'fontWhite', isTerminal: true  },
    { status: 'UNKNOWN', display: 'Unknown', color: '#FF0000', fontColor: 'fontBlack', isTerminal: false  },
];

export const getTerminalStatusList = () => {
    return BOOKING_STATUS_CONFIG.filter(config => config.isTerminal).map(config => config.status);
}

export const getStatusBgColor = (status) => {
    return BOOKING_STATUS_CONFIG.find(config => config.status === status)?.color ?? '#FF0000';
}

export const getStatusFontColor = (status) => {
    return BOOKING_STATUS_CONFIG.find(config => config.status === status)?.fontColor ?? 'fontBlack';
}

export const REMINDER_CALENDAR_LINK = "https://cal.com/tbd-health-clinician-1/tbd-clinician-reminder"